import React, { useEffect, useRef, useState } from 'react';

export default function InlineTextEditor({ value, updateText, deleteText, label = 'text' }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(value || '');
  const [saved, setSaved] = useState(value || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const input = useRef(null);
  useEffect(() => {
    setSaved(value || '');
    setText(value || '');
  }, [value]);
  useEffect(() => {
    if (editing) input.current?.focus();
  }, [editing]);
  const cancel = () => {
    setText(saved);
    setError('');
    setEditing(false);
  };
  const save = async (remove = false) => {
    setSaving(true);
    setError('');
    try {
      await (remove ? deleteText() : updateText(text));
      setSaved(remove ? '' : text);
      if (remove) setText('');
      setEditing(false);
    } catch (_) {
      setError('Could not save. Try again.');
    } finally {
      setSaving(false);
    }
  };
  if (!editing)
    return (
      <button className='inline-text-preview' title={saved || `Add ${label}`} aria-label={`Edit ${label}${saved ? `: ${saved}` : ''}`} onClick={() => setEditing(true)}>
        {saved || <span className='inline-text-placeholder'>Add {label}…</span>}
      </button>
    );
  return (
    <div className='inline-text-editor'>
      <textarea
        ref={input}
        aria-label={label}
        value={text}
        disabled={saving}
        onChange={e => setText(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Escape') {
            e.preventDefault();
            cancel();
          }
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!saving) save();
          }
        }}
      />
      <div className='inline-text-actions'>
        <button onClick={() => save()} disabled={saving}>
          {saving ? 'Saving…' : 'Save'}
        </button>
        <button onClick={cancel} disabled={saving}>
          Cancel
        </button>
        {saved && (
          <button onClick={() => save(true)} disabled={saving}>
            Clear
          </button>
        )}
      </div>
      {error && <span role='alert'>{error}</span>}
    </div>
  );
}
